import React from "react";
import { FaArrowRight } from "react-icons/fa";

const BrandButton = ({
  as: Component = "button",
  className = "",
  variant = "primary",
  navbar = false,
  accent,
  style,
  children,
  ...props
}) => {
  const accentStyle = accent
    ? {
        "--mk-btn-bg": accent.base,
        "--mk-btn-hover": accent.hover,
        "--mk-btn-dark": accent.dark,
        "--mk-btn-soft": accent.soft,
        "--mk-btn-rgb": accent.rgb,
        ...style,
      }
    : style;

  return (
    <Component
      className={`mk-cta-button mk-cta-button--${variant}${navbar ? " mk-cta-button--navbar" : ""} group ${className}`}
      style={accentStyle}
      {...props}
    >
      <span className="mk-cta-button__surface">
        <span className="mk-cta-button__label">{children}</span>
        <FaArrowRight aria-hidden="true" className="mk-cta-button__arrow" />
      </span>
    </Component>
  );
};

export default BrandButton;
